import React from 'react';
import styles from "./detail.module.scss";
import { formatNumberWithDot, getNumberWithOrdinalWithSuperscript, imageLink } from '../../../hooks/utils';

const CountryDataDetail = ({item, onClose}) =>{
  
    const countryName = item.country;
    const rank = item.rank !== null ? (<div className={styles.rankLabel}><span className={styles.rankNumber}>{getNumberWithOrdinalWithSuperscript(item.rank)}</span><span className={styles.rankLabelBottom}>IN W10</span></div>) : '';
    const urlText = item.urlText ? item.urlText : `Apply for residence in ${countryName}`;
    const url = item.url ? (<p className="mt-auto mb-0">{urlText} <a href={item.url} target="_blank" rel="noreferrer" className="text-underline">here</a></p>) : (<p className="mt-auto mb-0">&nbsp;</p>);


    return(
        <div className={`${styles.popup} ${styles.card}`}>
        <button className={styles.closeButton} onClick={onClose}>
            <svg width="10px" height="9px" viewBox="0 0 10 9">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-702.000000, -7.000000)" stroke="currentColor">
                        <g transform="translate(700.692388, 4.692388)">
                            <g transform="translate(6.500000, 6.500000) rotate(45.000000) translate(-6.500000, -6.500000) ">
                                <line x1="6.5" y1="1" x2="6.5" y2="12"></line>
                                <line x1="6.5" y1="1" x2="6.5" y2="11.5" transform="translate(6.500000, 6.250000) rotate(-90.000000) translate(-6.500000, -6.250000) "></line>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </button>
      
        <div className="row">
          <div className="col-md-4 col-lg-3 col-xl-4">
          <div className="countryImageWrapper">
                 <img src={imageLink(countryName)} alt={countryName} />
            </div>
          </div>
          <div className="col-md-8 col-lg-9 col-xl-8 d-flex flex-column justify-content-between pl-md-0">
            <h3 className="mt-4 mt-md-0 mb-3">{item.country}</h3>
            {rank}
            
            <div className="row">
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">Population (m)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.population)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">GDP per capita (USD)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.GDPPerCapita)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">Wealth per capita (USD)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.wealthPerCapita)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">Total Private Wealth (USDbn)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.totalWealth)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">HNWIs (USD1m+)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.HNWIs)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">Multi-millionaires (USD10m+)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.multiMillionaires)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">Centi-millionaires (USD100m+)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.centiMillionaires)}</h3>
              </div>
              <div className="col-6 col-md-4 col-lg-3 d-flex justify-content-between flex-column">
                <h5 className="field mb-0">Billionaires (USD1bn+)</h5>
                <h3 className={`mb-3 text-nowrap ${styles.value}`}>{formatNumberWithDot(item.billionaires)}</h3>
              </div>
            </div>

            {url}
          </div>

        </div>
      </div>
    )
}

export default CountryDataDetail;